import { RequestingCompany } from "../Form/types";
import { SortDirectionEnum } from "../Premises/types";

/* eslint-disable */
export enum Status {
  NEW_MESSAGE = "NEW_MESSAGE",
  BOOK_CLOSURE = "BOOK_CLOSURE",
  DRAFT = "DRAFT",
  LODGED = "LODGED",
  FINISHED = "FINISHED",
  NONE = "NONE",
}

export type RequestSummary = {
  total: number;
  drafts: number;
  lodged: number;
  book_closure: number;
  finished: number;
  new_message: number;
};

export interface Company {
  id: string;
  msa_number: string;
  name: string;
  created: string;
  updated: string;
  operational_team: string;
}

enum ProjectStatusEnum {
  ACTIVE = "ACTIVE",
  INACTIVE = "INACTIVE",
}

export type Project = {
  id: string;
  name: string;
  requesting_company: Company;
  sites: any[]; // Not used for now so any
  status?: ProjectStatusEnum;
  tag?: string;
};

export type ProjectSummary = {
  project: Project;
  gas_request_summary: RequestSummary;
  electricity_request_summary: RequestSummary;
  status: Status;
};

type Pageable = {
  page: number;
  total: number;
  limit: number;
};

export type ProjectsResponse = {
  pageable: Pageable;
  projects: ProjectSummary[];
};

export type SingleCompanyProjectsResonse = {
  pageable: Pageable;
  projects: Project[];
};
/* eslint-enable */

export interface Companies {
  companies: Company[];
}

export enum ProjectSortByEnum {
  NAME = "NAME",
  STATUS = "STATUS",
}

export interface FetchProjectsRequest {
  page?: number;
  limit?: number;
  sortDirection?: SortDirectionEnum;
  sortBy?: ProjectSortByEnum;
  incremental?: boolean;
}

export interface ProjectDropdownItem {
  label: string;
  value: string;
}

export type ProjectsTableRow = {
  name: string;
  id: string;
  requestingCompany?: RequestingCompany;
  drafts: number;
  submitted: number;
  lodged: number;
  book_closure: number;
  finished: number;
  stalled: number;
  status: Status;
  projectRaw: ProjectSummary;
};

export type ProjectsTableRows = ProjectsTableRow[];
